export function supplierPendingValues(detailsData) {
  let pendingValues;
  const commonValues = {
    erpId: "pending",
    erpName: "pending",
    countryOfOrigin: "pending",
    brand: "pending",
    packaging: "pending",
    productionDate: "pending",
    receiptDate: "pending",
    expiryDate: "pending",
    dateSupplierAdded: Date.now(),
    dateModified: Date.now(),
    deliveredDate: "pending",
    primaryProductImages: "pending",
    secondaryProductImages: "pending",
  };
  switch (detailsData.email.toLowerCase()) {
    case "procurement@ekfc.ae":
      pendingValues = {
        ...commonValues,
        execChefApproval: {
          status: "pending",
          comments: "pending",
          dateModified: "pending",
        },
        HODApproval: {
          status: "pending",
          comments: "pending",
          dateModified: "pending",
        },
      };
      break;
    case detailsData.executiveChefEmail.toLowerCase():
      pendingValues = {
        ...commonValues,
        execChefApproval: {
          status: "pending",
          comments: "pending",
          dateModified: "pending",
        },
        HODApproval: {
          status: "pending",
          comments: "pending",
          dateModified: "pending",
        },
      };
      break;
    case "hod":
      pendingValues = {
        ...commonValues,
        HODApproval: {
          status: "pending",
          comments: "pending",
          dateModified: "pending",
        },
      };
      break;

    default:
      pendingValues = {
        ...commonValues,
        userApproval: {
          status: "pending",
          comments: "pending",
          dateModified: "pending",
        },
        execChefApproval: {
          status: "pending",
          comments: "pending",
          dateModified: "pending",
        },
        HODApproval: {
          status: "pending",
          comments: "pending",
          dateModified: "pending",
        },
      };
      break;
  }

  return pendingValues;
}
